import React from "react";

const SectionTitle = ({ title }) => {
  return (
    <div className="my-10">
      <h2 className="title text-3xl">{title}</h2>
    </div>
  );
};

export default SectionTitle;
